import React, { useMemo } from 'react';
import SectionHeader from '../../common/SectionHeader';
import PurchaseCancelForm from './form/PurchaseCancelForm';
import PurchaseCancelReasonSection from './form/PurchaseCancelReasonSection';
import ReplacementPurchaseSelector from './form/ReplacementPurchaseSelector';
import { usePurchaseInvalidation } from '../../../hooks/purchases/invalidation/usePurchaseInvalidation';
import { DOCUMENT_TYPE_CODES } from '../../../constants/documentTypeCodes';
import { getPurchaseInvalidationDescriptions } from '../../../utils/purchase/purchaseInvalidationDescriptions';

const PurchaseCancelPanel: React.FC = () => {
  const { form, submitInvalidation, setErrors } = usePurchaseInvalidation();

  // 🔥 Normalizar SIEMPRE
  const type = String(form.invalidationTypeCode ?? '');

  const hasDocumentType = !!form.documentTypeCode;
  const isExcludedSubject =
    form.documentTypeCode === DOCUMENT_TYPE_CODES.EXCLUDED_SUBJECT;

  // 🔥 Regla centralizada (single source of truth)
  const requiresReplacement = useMemo(() => ['1', '3'].includes(type), [type]);

  const { dataDescription, reasonDescription } =
    getPurchaseInvalidationDescriptions(hasDocumentType, isExcludedSubject);

  // 🔥 Submit limpio y consistente
  const handleSubmit = () => {
    if (requiresReplacement && !form.replacementGenerationCode?.trim()) {
      setErrors?.({
        replacementGenerationCode: 'El documento de reemplazo es requerido',
      });
      return;
    }
    submitInvalidation();
  };

  return (
    <div className="flex flex-col divide-y divide-stroke dark:divide-strokedark">
      {/* 1️⃣ Datos base */}
      <div className="p-6">
        <SectionHeader
          title="Datos para anulación de compra"
          description={dataDescription}
        />
        <PurchaseCancelForm />
      </div>

      {/* 2️⃣ Reemplazo */}
      {requiresReplacement && (
        <div className="p-6">
          <SectionHeader
            title="Documento de reemplazo"
            description="Ingrese el código de generación de la compra que reemplaza al documento actual."
          />

          <ReplacementPurchaseSelector />
        </div>
      )}

      {/* 3️⃣ Justificación */}
      <div className="p-6">
        <SectionHeader
          title="Justificación del evento de anulación"
          description={reasonDescription}
        />
        <PurchaseCancelReasonSection onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default PurchaseCancelPanel;
